import type { Course } from "@brookbush/types";

import Link from "next/link";

const CourseRelatedCourses = ({
	relatedCourses,
}: {
	relatedCourses: Course["relatedCourses"];
}) => {
	if (!relatedCourses?.length) return null;

	return (
		<div className="max-h-full min-h-40 overflow-auto rounded-2xl border bg-white shadow shadow-black/5 dark:bg-slate-800 dark:shadow-slate-950">
			<div className="flex w-full flex-col self-start bg-white dark:bg-slate-700/50">
				<div className="sticky top-0 bg-slate-800">
					<h2 className="bg-white px-4 py-2 font-bold text-xl dark:bg-slate-700/50">
						Related Courses
					</h2>
				</div>

				<div className="mb-3 flex flex-col gap-2.5 px-5">
					{relatedCourses?.map((course) => (
						<Link
							href={`/courses/${course?.slug}`}
							key={course?.slug}
							className="line-clamp-2 shrink-0 font-medium capitalize hover:underline"
							prefetch={false}
						>
							{course?.title}
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};

export default CourseRelatedCourses;
